import GeofenceDetail from "./GeofenceDetail"

export default  GeofenceDetail;



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/index.js